import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { UtilService } from 'src/app/service/util';
import { Veiculo, VeiculoLista } from '../interface/veiculo';

@Injectable({
  providedIn: 'root'
})
export class VeiculoLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrbase/veiculo`;

  constructor(
    protected httpClient: HttpClient,
    protected utilService: UtilService
    ) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string, filtro: any): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get(`${this.url}/${value}`,httpOptions);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CDA3PLACA', divider: 'Placa',    optional: true, gridColumns: 6, label: 'Placa'},
      {property: 'CDA3DESC', divider: 'Descrição', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CDA3PLACA', label: 'Codigo'},
      {property: 'CDA3DESC', label: 'Descrição'},
    ];
  }

  getFieldFormater(value: Veiculo): string {
    return `${value.CDA3PLACA} - ${value.CDA3DESC}`;
  }


  getVeiculoLista(filtro:{}): Observable<VeiculoLista>{
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<VeiculoLista>(`${this.url}`, httpOptions);
  }

}
